import { ArrayUtils, engineComponent, NumberUtils } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { Paylines } from "../Paylines";
import { Symbols } from "../Symbols";
import { Machine } from "../Machine";
import { StageController } from "../../Components/StageController";
import { WinAnimator } from "../WinAnimator";
import { FreespinsController } from "./FreespinsController";
import { GameManager } from "../../Managers/GameManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { DataManager } from "../../Managers/DataManager";
import { WinAnimatorExtended } from "../../CustomComponents/WinAnimatorExtended";
import { MachineExtended } from "../../CustomComponents/MachineExtended";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { ImageTextCounterElement } from "../../Components/Elements/Texts/ImageTextCounterElement";
import { Tweens } from "../../Components/Effects/Tweens";
import { Communication } from "neo-games";
import { BaseView } from "../Base/BaseView";
import { FireFlieElement } from "../../CustomComponents/FireFlieElement";
import { AmbientBackground } from "../../Utils/AmbientBackground";

@engineComponent(ComponentTypes.DisplayObject)
export class FreespinsView extends ContainerElement {
    private _controller: FreespinsController;

    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;
    private startWinsDelay: FrameTimerEventEmitter;

    private _paylines: Paylines;
    private _symbols: Symbols;
    private _machine: MachineExtended;
    private _winAnimator: WinAnimatorExtended;

    private _fsMessageStart: HTMLElement;
    private _fsMessageWonFsCount: HTMLElement;
    private _fsMessageEnd: HTMLElement;
    private _fsMessageEndNoWin: HTMLElement;

    /**CUSTOM**/

    private changeMultiplierNumberDelay: FrameTimerEventEmitter;
    private _finishPickInfoWinNumber: FrameTimerEventEmitter;
    private _finishWinCalculationDelay: FrameTimerEventEmitter;
    private _finishPickInfoMultiplierNumber: FrameTimerEventEmitter;
    private _changeJackDelay: FrameTimerEventEmitter;
    private _playMultiplierWinSound: FrameTimerEventEmitter;
    private _playMultiplierCounterSound: FrameTimerEventEmitter;
    private _showMessagesDelay: FrameTimerEventEmitter;

    private winframes: ContainerElement;
    private multiplier: SwitchElement;
    private multiplierNumber: ImageTextCounterElement;
    private machineTop: ContainerElement;
    private fireflies: ContainerElement;
    private background: ContainerElement;
    private teasingEyesContainer: ContainerElement;
    private paylinesContainer: ContainerElement;
    private messageContainer: ContainerElement;
    private foregroundContainer: ContainerElement;
    private transitionScreenContainer: ContainerElement;
    private jackContainer: ContainerElement;
    private logoContainer: ContainerElement;
    private multiplierFireflies: Object;

    private messageWin: ImageTextCounterElement;
    private messageMultiplier: ImageTextCounterElement;
    private messageTotalWin: ImageTextCounterElement;

    private previousTotalWin: number = 0;

    private finalCounter: number = 1;
    private actualCounter: number = 1;
    private actualCounterSound: number = 1;

    private isLong: boolean = false;

    constructor() {
        super();

        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));

        this.startWinsDelay = CreateFrameTimer("startWinsDelay");
        this.startWinsDelay.on(FrameTimerEvents.Complete, this.showWins.bind(this));

        this.changeMultiplierNumberDelay = CreateFrameTimer("changeMultiplierNumberDelay");
        this.changeMultiplierNumberDelay.on(FrameTimerEvents.Complete, this.changeMultiplierNumber.bind(this));

        this._finishWinCalculationDelay = CreateFrameTimer("finishWinCalculationDelay");
        this._finishWinCalculationDelay.on(FrameTimerEvents.Complete, this.finishWinCalculationDelay.bind(this));

        this._finishPickInfoWinNumber = CreateFrameTimer("finishPickInfoWinNumber");
        this._finishPickInfoWinNumber.on(FrameTimerEvents.Complete, this.finishPickInfoWinNumber.bind(this));

        this._finishPickInfoMultiplierNumber = CreateFrameTimer("finishPickInfoMultiplierNumber");
        this._finishPickInfoMultiplierNumber.on(
            FrameTimerEvents.Complete,
            this.finishPickInfoMultiplierNumber.bind(this),
        );

        this._changeJackDelay = CreateFrameTimer("changeJackDelay");
        this._changeJackDelay.on(FrameTimerEvents.Complete, this.changeJackDelay.bind(this));

        this._playMultiplierWinSound = CreateFrameTimer("playMultiplierWinSound");
        this._playMultiplierWinSound.on(FrameTimerEvents.Complete, this.playMultiplierWinSound.bind(this));

        this._playMultiplierCounterSound = CreateFrameTimer("playMultiplierCounterSound");
        this._playMultiplierCounterSound.on(FrameTimerEvents.Complete, this.playMultiplierCounterSound.bind(this));

        this._showMessagesDelay = CreateFrameTimer("showMessagesDelay");
        this._showMessagesDelay.on(FrameTimerEvents.Complete, this.showMessages.bind(this));

        StageController.freespinsStageContainer = this;
    }

    create(node: Element): void {
        super.create(node);

        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof Paylines) {
                    this._paylines = this.childs[key];
                    this._paylines.reset();
                }

                if (this.childs[key] instanceof Symbols) {
                    this._symbols = this.childs[key];
                    this.removeChild(this._symbols);
                }

                if (this.childs[key] instanceof MachineExtended) {
                    this._machine = this.childs[key];
                }

                if (this.childs[key] instanceof WinAnimatorExtended) {
                    this._winAnimator = this.childs[key];
                }

                if (key === "WinFrames" && this.childs[key] instanceof ContainerElement) {
                    this.winframes = this.childs[key];
                }

                if (this.childs[key] instanceof SwitchElement && key == "Multiplier") {
                    this.multiplier = this.childs[key];
                    let container = <any>this.multiplier.children[0];
                    this.multiplierNumber = <any>container.children[0];
                }

                if (key === "MultiplierFireflies" && this.childs[key] instanceof ContainerElement) {
                    let container: ContainerElement = this.childs[key];
                    this.multiplierFireflies = container.childs;
                }

                if (key === "MachineTopFS" && this.childs[key] instanceof ContainerElement) {
                    this.machineTop = this.childs[key];
                }

                if (key === "BackgroundFS" && this.childs[key] instanceof ContainerElement) {
                    this.background = this.childs[key];
                }

                if (key === "TeasingEyesContainer" && this.childs[key] instanceof ContainerElement) {
                    this.teasingEyesContainer = this.childs[key];
                }

                if (key === "FirefliesFS" && this.childs[key] instanceof ContainerElement) {
                    this.fireflies = this.childs[key];
                }

                if (key === "PaylinesContainer" && this.childs[key] instanceof ContainerElement) {
                    this.paylinesContainer = this.childs[key];
                }

                if (key === "MessageContainer" && this.childs[key] instanceof ContainerElement) {
                    this.messageContainer = this.childs[key];
                }

                if (key === "ForegroundContainer" && this.childs[key] instanceof ContainerElement) {
                    this.foregroundContainer = this.childs[key];
                }

                if (key === "TransitionScreenContainer" && this.childs[key] instanceof ContainerElement) {
                    this.transitionScreenContainer = this.childs[key];
                }

                if (key === "JackContainer" && this.childs[key] instanceof ContainerElement) {
                    this.jackContainer = this.childs[key];
                }

                if (key === "LogoContainer" && this.childs[key] instanceof ContainerElement) {
                    this.logoContainer = this.childs[key];
                }
            }

            this._fsMessageStart = document.getElementById("fsMessageStart");
            this._fsMessageWonFsCount = document.getElementById("fsMessageWonFsCount");
            this._fsMessageEnd = document.getElementById("fsMessageEnd");
            this._fsMessageEndNoWin = document.getElementById("fsMessageEndNoWin");

            if (DEBUG) {
                if (this._paylines == null) {
                    this.log("WARNING no paylines");
                }

                if (this._symbols == null) {
                    this.log("ERROR no symbols");
                }

                if (this._machine == null) {
                    this.log("ERROR no machine");
                }

                if (this._winAnimator == null) {
                    this.log("WARNING no winAnimator");
                }

                if (this._fsMessageStart == null) {
                    this.log("ERROR no fsMessageStart");
                }

                if (this._fsMessageEnd == null) {
                    this.log("ERROR no fsMessageEnd");
                }

                if (this._fsMessageEndNoWin == null) {
                    this.log("ERROR no fsMessageEndNoWin");
                }
            }
        }
    }

    disableLogo(): void {
        if (this.childs["LogoContainer"] != null) {
            this.removeChild(this.childs["LogoContainer"]);
        }
    }

    initReceived(controller: FreespinsController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.freespinsResponse != null) {
                    if (
                        GameManager.freespinsResponse.initData != null &&
                        GameManager.freespinsResponse.initData.reels !== null
                    ) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.initialize(
                            this._symbols,
                            GameManager.freespinsResponse.initData.reels,
                            null,
                            null,
                        );
                    }

                    if (this._winAnimator != null) {
                        this._winAnimator.on(WinAnimator.FinishWinCalculation, this.finishWinCalculation.bind(this));
                        this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                        this._winAnimator.initialize(
                            this._symbols,
                            this._paylines,
                            this.childs["NoWinContainer"],
                            this.childs["WinContainer"],
                            null,
                            null,
                            null,
                            this.winframes,
                        );
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no freespin reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }

        this.visible = false;
    }

    initIntro(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;
        StageController.baseStageContainer.visible = false;
        StageController.pickStageContainer.visible = false;

        this.fireflies.addChild(BaseView.FireFlies);
        this.background.addChild(BaseView.Background);
        if (this.teasingEyesContainer != null) {
            this.teasingEyesContainer.addChild(BaseView.TeasingEyes);
        }
        this.machineTop.addChild(BaseView.MachineTop);
        this.paylinesContainer.addChild(BaseView.PaylinesContainer);
        this.messageContainer.addChild(BaseView.Message);
        this.transitionScreenContainer.addChild(BaseView.TransitionScreen);
        this.jackContainer.addChild(BaseView.Jack);
        this.logoContainer.addChild(BaseView.Logo);
        this.foregroundContainer.addChild(BaseView.Foreground);

        let cash: SwitchElement = <any>BaseView.Message.getChildElementByName("Cash");
        let multiplier: SwitchElement = <any>BaseView.Message.getChildElementByName("Multiplier");
        let totalCash: SwitchElement = <any>BaseView.Message.getChildElementByName("TotalCash");

        this.messageWin = <any>cash.getChildElementByName("MultiplierNumber");
        this.messageMultiplier = <any>multiplier.getChildElementByName("MultiplierNumber");
        this.messageTotalWin = <any>totalCash.getChildElementByName("MultiplierNumber");

        AmbientBackground.changeAmbientBackground("fs", 1000, 5000);

        BaseView.Message.goToCase("EMPTY");
        BaseView.Jack.goToCase("EMPTY");
        BaseView.FireFlies.goToCase("FS");
        BaseView.Background.goToCase("FS");
        BaseView.Foreground.goToCase("FS");
        BaseView.Logo.goToCase("FS");

        BaseView.MachineTop.goToCase("FS");

        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);

        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);

        let currentWin: number = this.isLastFreespin()
            ? GameManager.freespinsResponse.freeSpins.customData.lastRoundWin
            : GameManager.freespinsResponse.currentWin;
        let wins: Array<Communication.Game.IWin> = GameManager.freespinsResponse.wins.filter(
            (value: Communication.Game.IWin) => {
                return value.trigger != Communication.Game.WinTrigger.Custom;
            },
        );

        this._winAnimator.showInitWins(wins, currentWin);

        this.visible = true;

        this.finalCounter =
            GameManager.freespinsResponse.freeSpins.hasOwnProperty("customData") &&
            GameManager.freespinsResponse.freeSpins.customData.hasOwnProperty("totalWinMultiplier")
                ? GameManager.freespinsResponse.freeSpins.customData.totalWinMultiplier
                : 1;
        this.actualCounter = this.finalCounter;

        if (this.finalCounter != 0) {
            this.multiplier.goToCase("NORMAL");
            this.multiplierNumber.start(this.finalCounter, this.finalCounter, 5);
        }

        if (GameManager.freespinsResponse.currentWin > 0) {
            this.setChildIndex(this.machineTop, this.getChildIndex(this.winframes));
        } else {
            this.setChildIndex(this.machineTop, this.getChildIndex(this.childs["LogoContainer"]) - 1);
        }

        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_FSWait");
            PlayList.play("SND_FSEnd");
            PlayList.loop("SND_FSEndLoop");

            if (GameManager.freespinsResponse.totalWin > 0) {
                if (this._fsMessageEnd != null && this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)) {
                    this._fsMessageEnd.classList.remove(HtmlController.DisabledClass);
                    this._fsMessageEnd.classList.add("init");
                    BaseView.Message.goToCase("END_MESSAGE_WIN_FS");
                    BaseView.Jack.goToCase("BASE_WAITING");
                    this.previousTotalWin = parseFloat(
                        NumberUtils.devide(GameManager.freespinsResponse.totalWin, this.finalCounter),
                    );
                    this.countMessageValues(true);
                    this._winAnimator.startIdleJack();
                }
            } else {
                if (
                    this._fsMessageEndNoWin != null &&
                    this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
                ) {
                    this._fsMessageEndNoWin.classList.remove(HtmlController.DisabledClass);
                    this._fsMessageEndNoWin.classList.add("init");
                    BaseView.Message.goToCase("END_MESSAGE_NOWIN_FS");
                    BaseView.Jack.goToCase("BASE_WAITING");
                }
            }

            BaseView.Foreground.goToCase("EMPTY");
            this.multiplier.goToCase("EMPTY");
        } else {
            PlayList.loop("SND_FSLoop");
        }
    }

    spin(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;

        PlayList.stop("SND_BaseRecapLoop");

        Tweens.removeTweens(this.childs["PaylinesContainer"]);
        Tweens.removeTweens(this.childs["WinContainer"]);
        Tweens.removeTweens(this.childs["NoWinContainer"]);
        Tweens.removeTweens(this.childs["WinFrames"]);

        this.childs["PaylinesContainer"].scale.x = 1;
        this.childs["PaylinesContainer"].scale.y = 1;
        this.childs["PaylinesContainer"].alpha = 1;
        this.childs["WinContainer"].scale.x = 1;
        this.childs["WinContainer"].scale.y = 1;
        this.childs["WinContainer"].alpha = 1;
        this.childs["NoWinContainer"].scale.x = 1;
        this.childs["NoWinContainer"].scale.y = 1;
        this.childs["NoWinContainer"].alpha = 1;
        this.childs["WinFrames"].scale.x = 1;
        this.childs["WinFrames"].scale.y = 1;
        this.childs["WinFrames"].alpha = 1;

        PlayList.loop("SND_FSLoop");
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);

        let isHighWin = this._winAnimator.reset(true, true);

        if (isHighWin) {
            this._controller.isHighWin();
        }

        this._machine.spinStart(isHighWin, true, this._winAnimator.currentSymbols);
        this.setChildIndex(this.machineTop, this.getChildIndex(this.childs["LogoContainer"]) - 1);

        this.previousTotalWin = GameManager.freespinsResponse.totalWin;
    }

    stop(): void {
        this._machine.spinStop(null, true);
    }

    startReceived(): void {
        if (this._fsMessageStart != null && !this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.add(HtmlController.DisabledClass);
            PlayList.play("SND_BaseMessageOut");
        }

        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
    }

    spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._machine.spinStop(null, false, true);
    }

    endReceived(): void {}

    onReelStopped(): void {
        let symbols: Array<number> =
            GameManager.freespinsResponse.screen.reels[this._machine.actualReelStopped].symbols;
        for (let i = 0; i < symbols.length; i++) {
            if (symbols[i] == 14) {
                this.multiplierFireflies["Fireflie" + this._machine.actualReelStopped + i].goToCase("NORMAL");
                this.multiplierFireflies["Fireflie" + this._machine.actualReelStopped + i].setOrigin();
            }
        }
        this._winAnimator.onReelStopped(GameManager.freespinsResponse.screen.reels, this._machine.actualReelStopped);
    }

    machineStopped(): void {
        // this._controller.machineStopped();

        this.actualCounterSound = 1;

        this.finalCounter =
            GameManager.freespinsResponse.freeSpins.hasOwnProperty("customData") &&
            GameManager.freespinsResponse.freeSpins.customData.hasOwnProperty("totalWinMultiplier")
                ? GameManager.freespinsResponse.freeSpins.customData.totalWinMultiplier
                : 0;

        if (this.finalCounter != 0 && this.actualCounter < this.finalCounter) {
            this._controller.disable();

            let showMultipliers: Array<Array<number>> = [[], [], [], [], []];

            GameManager.freespinsResponse.screen.reels.map((value: any, index: number) => {
                for (let i = 0; i < value.symbols.length; i++) {
                    if (value.symbols[i] == 14) {
                        showMultipliers[index].push(i);
                    }
                }
            });

            let counter: number = 0;
            for (let i = 0; i < showMultipliers.length; i++) {
                for (let j = 0; j < showMultipliers[i].length; j++) {
                    if (showMultipliers[i].length > 0) {
                        this.multiplierFireflies["Fireflie" + i + showMultipliers[i][j]].setOrigin();
                        this.multiplierFireflies["Fireflie" + i + showMultipliers[i][j]].setDynamicTime(counter);
                        this.multiplierFireflies["Fireflie" + i + showMultipliers[i][j]].goToCase("START");
                        counter += 60;
                        this.multiplierFireflies["Fireflie" + i + showMultipliers[i][j]].start(counter);
                        this._winAnimator.setDynamicTimeOnSymbol(i, showMultipliers[i][j], counter);
                    }
                }
            }

            this.changeMultiplierNumber(this.actualCounter, 90, true);

            this.startWinsDelay.start(counter + 60);
        } else {
            this.showWins();
        }
    }

    changeMultiplierNumber(actualCounter: number, delay: number = 0, first: boolean = false): void {
        if (actualCounter != this.finalCounter) {
            // this.multiplier.goToCase('POP');
            this.multiplierNumber.start(actualCounter, actualCounter + 1, 5, delay);

            this.actualCounterSound = actualCounter;
            this._playMultiplierCounterSound.start(delay);

            actualCounter++;

            Tweens.removeTweens(this, "changeNumber");
            Tweens.customTween(this, {
                tween: "changeNumber",
                tweenValues: [0, 0],
                tweenDelay: [delay],
                tweenDuration: [30],
                callbackType: "onComplete",
                callbackFunction: this.changeMultiplierNumber,
                callbackScope: this,
                callbackParams: [actualCounter, 30],
            });

            if (actualCounter == this.finalCounter) {
                this.multiplierNumber.makeTween(delay + 10);
                this._playMultiplierWinSound.start(delay + 10);
            }
        } else {
            this.actualCounter = this.finalCounter;
        }
    }

    playMultiplierWinSound(): void {
        PlayList.play("SND_BonusMultiplierLast");
    }

    playMultiplierCounterSound(): void {
        if (this.actualCounterSound < 4) {
            PlayList.play("SND_BonusMultiplier1");
        } else if (this.actualCounterSound < 7) {
            PlayList.play("SND_BonusMultiplier2");
        } else {
            PlayList.play("SND_BonusMultiplier3");
        }
    }

    showWins(): void {
        this._controller.machineStopped();

        // let currentWin: number = (this.isLastFreespin()?GameManager.freespinsResponse.freeSpins.customData.lastRoundWin:GameManager.freespinsResponse.currentWin)
        let currentWin: number = this.isLastFreespin()
            ? DataManager.GameLimit
                ? GameManager.freespinsResponse.currentWin
                : GameManager.freespinsResponse.freeSpins.customData.lastRoundWin
            : GameManager.freespinsResponse.currentWin;
        let wins: Array<Communication.Game.IWin> = GameManager.freespinsResponse.wins.filter(
            (value: Communication.Game.IWin) => {
                return value.trigger != Communication.Game.WinTrigger.Custom;
            },
        );

        this.jackContainer.addChild(BaseView.Jack);

        if (this._winAnimator.showWins(wins, currentWin)) {
            PlayList.stop("SND_FSLoop");

            let tweenValues: Array<number> = this.formatTweenValues("scale.x", ArrayUtils.stringArray("1;1;0.85"));
            let tweenDuration: Array<number> = ArrayUtils.numberArray("60;60");
            let tweenEase: Array<string> = ArrayUtils.stringArray("linear;backInOut");
            let tweenDelay: Array<number> = ArrayUtils.numberArray("0");

            Tweens.removeTweens(this.childs["PaylinesContainer"], "scale.x");
            Tweens.customTween(this.childs["PaylinesContainer"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1;0.85"));
            Tweens.removeTweens(this.childs["PaylinesContainer"], "scale.y");
            Tweens.customTween(this.childs["PaylinesContainer"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1;0.85"));
            Tweens.removeTweens(this.childs["WinContainer"], "scale.x");
            Tweens.customTween(this.childs["WinContainer"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1;0.85"));
            Tweens.removeTweens(this.childs["WinContainer"], "scale.y");
            Tweens.customTween(this.childs["WinContainer"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1;0.85"));
            Tweens.removeTweens(this.childs["NoWinContainer"], "scale.x");
            Tweens.customTween(this.childs["NoWinContainer"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1;0.85"));
            Tweens.removeTweens(this.childs["NoWinContainer"], "scale.y");
            Tweens.customTween(this.childs["NoWinContainer"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1;0.85"));
            Tweens.removeTweens(this.childs["WinFrames"], "scale.x");
            Tweens.customTween(this.childs["WinFrames"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1;0.85"));
            Tweens.removeTweens(this.childs["WinFrames"], "scale.y");
            Tweens.customTween(this.childs["WinFrames"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });
        }

        if (wins.length > 0) {
            this.setChildIndex(this.machineTop, this.getChildIndex(this.winframes));
        }

        if (this.isLastFreespin()) {
            if (GameManager.freespinsResponse.freeSpins.customData.lastRoundWin === 0) {
                this._showMessagesDelay.start(45);
            }
        }
    }

    showMessages(): void {
        PlayList.stop("SND_FSLoop");
        PlayList.loop("SND_FSWait");
        PlayList.play("SND_FSEnd");
        PlayList.loop("SND_FSEndLoop");

        if (GameManager.freespinsResponse.totalWin > 0) {
            if (this._fsMessageEnd != null && this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)) {
                this._fsMessageEnd.classList.remove(HtmlController.DisabledClass);
                PlayList.play("SND_BaseMessageIn");
                BaseView.Message.goToCase("END_MESSAGE_WIN_FS");
                BaseView.Jack.goToCase("BASE_INCOME");
                this.countMessageValues();
                this._winAnimator.startIdleJack();
            }
        } else {
            if (
                this._fsMessageEndNoWin != null &&
                this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
            ) {
                this._fsMessageEndNoWin.classList.remove(HtmlController.DisabledClass);
                PlayList.play("SND_BaseMessageIn");
                this._fsMessageEndNoWin.classList.add("start");
                BaseView.Message.goToCase("END_MESSAGE_NOWIN_FS");
                BaseView.Jack.goToCase("BASE_INCOME");
            }
        }
    }

    countMessageValues(isInit: boolean = false): void {
        let duration: number = 0;
        if (!isInit) {
            duration = 60;
        }

        if (isInit) {
            this.messageWin.start(this.previousTotalWin, this.previousTotalWin, 1);
            this.messageMultiplier.start(this.finalCounter, this.finalCounter, 1);
            this.messageTotalWin.start(
                GameManager.freespinsResponse.totalWin,
                GameManager.freespinsResponse.totalWin,
                1,
            );
        } else {
            let msgs1: Array<Element> = <any>this._fsMessageEnd.getElementsByClassName("msg_1");

            for (let i = 0; i < msgs1.length; i++) {
                msgs1[i].classList.add("start");
            }

            this.messageWin.start(0, this.previousTotalWin, duration);
            this.messageMultiplier.start(1, 1, 1);
            Tweens.removeTweens(this.messageMultiplier, "all");
            Tweens.removeTweens(this.messageMultiplier, "changeMessageMultiplierNumber");
            this.messageMultiplier.alpha = 0;
            this.messageTotalWin.alpha = 0;

            this._finishPickInfoWinNumber.start(duration);

            PlayList.loop("SND_BonusCreditboxLoop");
        }
    }

    finishPickInfoWinNumber(): void {
        Tweens.removeTweens(this.messageMultiplier, "all");
        PlayList.stop("SND_BonusCreditboxLoop");
        PlayList.play("SND_BonusCreditboxEnd");
        this.messageMultiplier.start(1, 1, 0);
        this.messageMultiplier.alpha = 1;

        let msgs2: Array<Element> = <any>this._fsMessageEnd.getElementsByClassName("msg_2");

        for (let i = 0; i < msgs2.length; i++) {
            if (!msgs2[i].classList.contains("start")) {
                msgs2[i].classList.add("start");
            }
        }

        this.changeMessageMultiplierNumber(0, this.finalCounter, 5, 0, 0);

        let finalValueDelay = 0;
        for (let i = 0; i < this.finalCounter; i++) {
            finalValueDelay = finalValueDelay + 5 + i;
        }

        this._finishPickInfoMultiplierNumber.start(finalValueDelay);

        this._winAnimator.stopTimer();
        BaseView.Jack.goToCase("FS_FINISHED");
        this._winAnimator.startIdleJack();
    }

    finishPickInfoMultiplierNumber(): void {
        // this.multiplier.goToCase('EMPTY');
        // BaseView.Foreground.goToCase('EMPTY');

        let tweenEase: Array<string> = ArrayUtils.stringArray("linear");
        let tweenDelay: Array<number> = ArrayUtils.numberArray("0");
        Tweens.removeTweens(this.messageTotalWin, "all");
        let tweenDuration: Array<number> = [15];
        let tweenValues: Array<number> = this.formatTweenValues("alpha", ArrayUtils.stringArray("0;1"));
        Tweens.customTween(this.messageTotalWin, {
            tween: "alpha",
            tweenValues,
            tweenEase,
            tweenDuration,
            tweenDelay,
            tweenLoop: false,
        });

        this.messageTotalWin.start(0, GameManager.freespinsResponse.totalWin, 120);

        let msgs3: Array<Element> = <any>this._fsMessageEnd.getElementsByClassName("msg_3");

        for (let i = 0; i < msgs3.length; i++) {
            msgs3[i].classList.add("start");
        }

        PlayList.loop("SND_BonusMessageCreditboxLoop");
        this._finishWinCalculationDelay.start(120);
    }

    changeMessageMultiplierNumber(
        actualCounter: number,
        finalCounter: number,
        duration: number,
        firstDelay: number = 0,
        finalDelay: number,
    ): void {
        if (actualCounter <= finalCounter) {
            let delay = finalDelay + firstDelay + duration;
            let tweenValues: Array<number> = this.formatTweenValues("scale.x", ArrayUtils.stringArray("1;1.5;1"));
            let tweenDuration: Array<number> = [duration / 4, duration / 4];
            let tweenEase: Array<string> = ArrayUtils.stringArray("linear");
            let tweenDelay: Array<number> = ArrayUtils.numberArray("0");

            if (actualCounter != finalCounter) {
                this.messageMultiplier.start(actualCounter, actualCounter + 1, duration, firstDelay);
                this.multiplierNumber.start(finalCounter - actualCounter, finalCounter - actualCounter - 1, duration);
            }

            tweenValues = this.formatTweenValues("scale.x", ArrayUtils.stringArray("1;1.5;1"));
            tweenDuration = [duration / 4, duration / 4];
            tweenEase = ArrayUtils.stringArray("linear");
            tweenDelay = ArrayUtils.numberArray("0");

            Tweens.removeTweens(this.messageMultiplier, "scale.x");
            Tweens.customTween(this.messageMultiplier, {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1.5;1"));
            Tweens.removeTweens(this.messageMultiplier, "scale.y");
            Tweens.customTween(this.messageMultiplier, {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            actualCounter++;
            let lastDuration: number = duration;
            duration++;

            if (actualCounter == finalCounter) {
                this.multiplier.goToCase("EMPTY");
                BaseView.Foreground.goToCase("EMPTY");
                this.messageMultiplier.makeTween(10);
                this._playMultiplierWinSound.start(10);
            } else {
                if (actualCounter < 4) {
                    PlayList.play("SND_BonusMultiplier1");
                } else if (actualCounter < 7) {
                    PlayList.play("SND_BonusMultiplier2");
                } else {
                    PlayList.play("SND_BonusMultiplier3");
                }
            }

            Tweens.removeTweens(this.messageMultiplier, "changeMessageMultiplierNumber");
            Tweens.customTween(this.messageMultiplier, {
                tween: "changeMessageMultiplierNumber",
                tweenValues: [0, 0],
                tweenDuration: [lastDuration],
                callbackType: "onComplete",
                callbackFunction: this.changeMessageMultiplierNumber,
                callbackScope: this,
                callbackParams: [actualCounter, finalCounter, duration, 0, delay],
                tweenDelay: [firstDelay],
            });
        } else {
        }
    }

    finishWinCalculationDelay(): void {
        PlayList.stop("SND_BonusMessageCreditboxLoop");
        PlayList.play("SND_BonusMessageCreditboxEnd");
        this._controller.showTotalWin();
    }

    finishWinCalculation(): void {
        this._controller.winCalculationFinished();

        if (this._winAnimator.getAnimationIndex() >= 3) {
            this._changeJackDelay.start(120);

            let tweenValues: Array<number> = this.formatTweenValues("scale.x", ArrayUtils.stringArray("0.75;1"));
            let tweenDuration: Array<number> = ArrayUtils.numberArray("30");
            let tweenEase: Array<string> = ArrayUtils.stringArray("backInOut");
            let tweenDelay: Array<number> = ArrayUtils.numberArray("0");

            Tweens.removeTweens(this.childs["PaylinesContainer"], "scale.x");
            Tweens.customTween(this.childs["PaylinesContainer"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("0.75;1"));
            Tweens.removeTweens(this.childs["PaylinesContainer"], "scale.y");
            Tweens.customTween(this.childs["PaylinesContainer"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("0.75;1"));
            Tweens.removeTweens(this.childs["WinContainer"], "scale.x");
            Tweens.customTween(this.childs["WinContainer"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("0.75;1"));
            Tweens.removeTweens(this.childs["WinContainer"], "scale.y");
            Tweens.customTween(this.childs["WinContainer"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("0.75;1"));
            Tweens.removeTweens(this.childs["NoWinContainer"], "scale.x");
            Tweens.customTween(this.childs["NoWinContainer"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("0.75;1"));
            Tweens.removeTweens(this.childs["NoWinContainer"], "scale.y");
            Tweens.customTween(this.childs["NoWinContainer"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("0.75;1"));
            Tweens.removeTweens(this.childs["WinFrames"], "scale.x");
            Tweens.customTween(this.childs["WinFrames"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("0.75;1"));
            Tweens.removeTweens(this.childs["WinFrames"], "scale.y");
            Tweens.customTween(this.childs["WinFrames"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });
        }
    }

    changeJackDelay(): void {
        if (this.isLastFreespin()) {
            this.jackContainer.addChild(BaseView.Jack);
        } else {
            BaseView.Jack.goToCase("HIGH_WIN_LEAVE");
        }
    }

    finishWinAnimator(): void {
        this._controller.allWinsFinished();

        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_FSWait");
            PlayList.play("SND_FSEnd");
            PlayList.loop("SND_FSEndLoop");

            if (GameManager.freespinsResponse.totalWin > 0) {
                if (this._fsMessageEnd != null && this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)) {
                    this._fsMessageEnd.classList.remove(HtmlController.DisabledClass);
                    BaseView.Message.goToCase("END_MESSAGE_WIN_FS");
                    if (BaseView.Jack.getCurrentCase().indexOf("HIGH_WIN") == -1) {
                        BaseView.Jack.goToCase("BASE_INCOME");
                    }
                    this.previousTotalWin = parseFloat(
                        NumberUtils.devide(GameManager.freespinsResponse.totalWin, this.finalCounter),
                    );
                    this.countMessageValues();
                    this._winAnimator.startIdleJack();
                }
            } else {
                if (
                    this._fsMessageEndNoWin != null &&
                    this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
                ) {
                    this._fsMessageEndNoWin.classList.remove(HtmlController.DisabledClass);
                    BaseView.Message.goToCase("END_MESSAGE_NOWIN_FS");
                    BaseView.Jack.goToCase("BASE_INCOME");
                }
            }
        } else {
            PlayList.loop("SND_FSLoop");
        }
    }

    intro(long: boolean = false): void {
        StageController.freespinStage = true;
        StageController.baseStageContainer.visible = false;
        StageController.pickStageContainer.visible = false;

        PlayList.stop("SND_FSWait");

        this.isLong = long;
        this.visible = true;
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        // this._winAnimator.reset(true);
        this.multiplier.goToCase("EMPTY");
        this.setChildIndex(this.machineTop, this.getChildIndex(this.childs["LogoContainer"]) - 1);
        this.background.addChild(BaseView.Background);
        if (this.teasingEyesContainer != null) {
            this.teasingEyesContainer.addChild(BaseView.TeasingEyes);
        }
        this.fireflies.addChild(BaseView.FireFlies);
        this.machineTop.addChild(BaseView.MachineTop);
        this.paylinesContainer.addChild(BaseView.PaylinesContainer);
        this.messageContainer.addChild(BaseView.Message);
        this.foregroundContainer.addChild(BaseView.Foreground);
        this.transitionScreenContainer.addChild(BaseView.TransitionScreen);
        this.jackContainer.addChild(BaseView.Jack);
        this.logoContainer.addChild(BaseView.Logo);

        AmbientBackground.changeAmbientBackground("fs", 1000, 4000);
        BaseView.Background.goToCase("TO_FS");
        if (BaseView.TeasingEyes != null) {
            BaseView.TeasingEyes.goToCase("TO_FS");
        }
        BaseView.FireFlies.goToCase("TO_FS");
        BaseView.Foreground.goToCase("TO_FS");
        BaseView.PaylinesContainer.goToCase("TO_FS");
        BaseView.Message.goToCase("EMPTY");
        BaseView.Jack.goToCase("TO_FS");

        BaseView.MachineTop.goToCase("TO_FS");

        let cash: SwitchElement = <any>BaseView.Message.getChildElementByName("Cash");
        let multiplier: SwitchElement = <any>BaseView.Message.getChildElementByName("Multiplier");
        let totalCash: SwitchElement = <any>BaseView.Message.getChildElementByName("TotalCash");

        this.messageWin = <any>cash.getChildElementByName("MultiplierNumber");
        this.messageMultiplier = <any>multiplier.getChildElementByName("MultiplierNumber");
        this.messageTotalWin = <any>totalCash.getChildElementByName("MultiplierNumber");

        let tweenValues: Array<number> = this.formatTweenValues("alpha", ArrayUtils.stringArray("1;1;0"));
        let tweenDuration: Array<number> = ArrayUtils.numberArray("30;60");
        let tweenEase: Array<string> = ArrayUtils.stringArray("linear");
        let tweenDelay: Array<number> = ArrayUtils.numberArray("0");

        Tweens.removeTweens(this.childs["WinContainer"], "all");
        tweenDuration = [495, 15];
        tweenValues = this.formatTweenValues("alpha", ArrayUtils.stringArray("0;0;1"));
        Tweens.customTween(this.childs["WinContainer"], {
            tween: "alpha",
            tweenValues,
            tweenEase,
            tweenDuration,
            tweenDelay,
            tweenLoop: false,
        });

        Tweens.removeTweens(BaseView.PaylinesContainer, "alpha");
        tweenValues = this.formatTweenValues("alpha", ArrayUtils.stringArray("1;0;0;1"));
        Tweens.customTween(BaseView.PaylinesContainer, {
            tween: "alpha",
            tweenValues,
            tweenEase,
            tweenDuration: [15, 450, 15],
            tweenDelay,
            tweenLoop: false,
        });

        Tweens.removeTweens(BaseView.FireFlies, "alpha");
        tweenValues = this.formatTweenValues("alpha", ArrayUtils.stringArray("1;0;0;1"));
        Tweens.customTween(BaseView.FireFlies, {
            tween: "alpha",
            tweenValues,
            tweenEase,
            tweenDuration: [15, 450, 15],
            tweenDelay,
            tweenLoop: false,
        });

        Tweens.removeTweens(this.childs["Leafs"], "alpha");
        tweenValues = this.formatTweenValues("alpha", ArrayUtils.stringArray("1;0;0;1"));
        Tweens.customTween(this.childs["Leafs"], {
            tween: "alpha",
            tweenValues,
            tweenEase,
            tweenDuration: [15, 450, 15],
            tweenDelay,
            tweenLoop: false,
        });
        this.childs["Leafs"].start();

        this.multiplierNumber.start(1, 1, 1);

        BaseView.Jack.goToCase("INTRO_FS");

        Tweens.removeTweens(this, "position.x");
        tweenValues = this.formatTweenValues(
            "position.x",
            ArrayUtils.stringArray("0;4;-5;5;4;-5;5;-3;4;-5;0;4;-5;5;4;-5;5;-3;4;-5;0"),
        );
        Tweens.customTween(this, {
            tween: "position.x",
            tweenValues,
            tweenEase,
            tweenDuration: [90],
            tweenDelay: [50],
            tweenLoop: false,
        });

        Tweens.removeTweens(this, "position.y");
        tweenValues = this.formatTweenValues(
            "position.y",
            ArrayUtils.stringArray("0;5;3;6;5;3;6;0;3;5;0;5;3;6;5;3;6;0;3;5;0"),
        );
        Tweens.customTween(this, {
            tween: "position.y",
            tweenValues,
            tweenEase,
            tweenDuration: [90],
            tweenDelay: [50],
            tweenLoop: false,
        });

        this._introDelay.start(500);
    }

    introFinished(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;

        BaseView.Logo.goToCase("FS_SHOW");

        this.visible = true;

        this.actualCounter = 1;

        if (this.isLong) {
            this.multiplier.goToCase("INTRO");
            this.isLong = false;
        } else {
            this.multiplier.goToCase("NORMAL");
        }

        PlayList.loop("SND_FSLoop");

        this._controller.introFinished();
    }

    outro(): void {
        StageController.freespinStage = true;

        let tweenValues: Array<number> = this.formatTweenValues("alpha", ArrayUtils.stringArray("1;1;0"));
        let tweenDuration: Array<number> = ArrayUtils.numberArray("30;60");
        let tweenEase: Array<string> = ArrayUtils.stringArray("linear");
        let tweenDelay: Array<number> = ArrayUtils.numberArray("0");

        Tweens.removeTweens(this.childs["WinContainer"], "all");
        tweenDuration = [40, 40];
        tweenValues = this.formatTweenValues("alpha", ArrayUtils.stringArray("1;1;0"));
        Tweens.customTween(this.childs["WinContainer"], {
            tween: "alpha",
            tweenValues,
            tweenEase,
            tweenDuration,
            tweenDelay,
            tweenLoop: false,
        });

        AmbientBackground.changeAmbientBackground("base", 660, 660);

        BaseView.Jack.goToCase("TO_BASE");
        BaseView.Background.goToCase("TO_BASE");
        BaseView.MachineTop.goToCase("TO_BASE");
        BaseView.TransitionScreen.goToCase("TO_BASE");
        BaseView.Foreground.goToCase("TO_BASE");
        BaseView.FireFlies.goToCase("TO_BASE");
        BaseView.PaylinesContainer.goToCase("TO_BASE");

        this.multiplier.goToCase("TO_BASE");
        BaseView.Logo.goToCase("FS_OUTRO");
        this.visible = true;
        BaseView.OutroFrom = "FS";

        PlayList.stop("SND_FSLoop");
        PlayList.stop("SND_FSWait");
        PlayList.stop("SND_FSEndLoop");
        PlayList.stop("SND_BaseRecapLoop");
        PlayList.play("SND_FSTransOut");

        if (this._fsMessageEnd != null && !this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)) {
            PlayList.play("SND_BaseMessageOut");
            this._fsMessageEnd.classList.add(HtmlController.DisabledClass);
            this._fsMessageEnd.classList.remove("start");
            BaseView.Message.goToCase("EMPTY");
            let msgs: Array<HTMLSpanElement> = <any>this._fsMessageEnd.getElementsByTagName("span");
            for (let i = 0; i < msgs.length; i++) {
                msgs[i].classList.remove("start");
            }
        }

        if (
            this._fsMessageEndNoWin != null &&
            !this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
        ) {
            PlayList.play("SND_BaseMessageOut");
            this._fsMessageEndNoWin.classList.add(HtmlController.DisabledClass);
            this._fsMessageEndNoWin.classList.remove("start");
            BaseView.Message.goToCase("EMPTY");
        }

        this._winAnimator.reset(true);
        this.setChildIndex(this.machineTop, this.getChildIndex(this.childs["LogoContainer"]) - 1);

        this._winAnimator.stopTimer();
        BaseView.PaylinesContainer.goToCase("TO_BASE");

        this._outroDelay.start(200);
    }

    outroFinished(): void {
        StageController.freespinStage = false;

        this.visible = false;

        this.childs["Leafs"].stop();

        this._controller.outroFinished();
    }

    enable(isInit: boolean = false): void {
        PlayList.play("SND_FSWin");
        PlayList.loop("SND_FSWinLoop");
        PlayList.loop("SND_FSWait");

        if (this._fsMessageStart != null && this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.remove(HtmlController.DisabledClass);
            if (isInit) {
                this._fsMessageStart.classList.add("init");
            } else {
                this._fsMessageStart.classList.add("start");
                PlayList.play("SND_BaseMessageIn");
            }
            BaseView.Message.goToCase("START_MESSAGE_FS");
        }
    }

    private isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            return true;
        }

        return (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0
        );
    }

    selectPayline(id?: number): void {
        // if (this._paylinesSelector != null) {
        //     this._paylinesSelector.select(id);
        // }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsView.ts
 **/